export const TRACKING_EVENTS = {
  // Page view events
  PAGE_VIEW: 'page_view',

  // Search events
  SEARCH_QUERY: 'search',

  VIEW_ITEM: 'view_item',
  VIEW_ITEM_LIST: 'view_item_list',
  VIEW_PROMOTION: 'view_promotion',
  VIEW_BANNER: 'view_banner',
  VIEW_RECIPE: 'view_recipe',

  // Navigation bar events
  NAVIGATION_BAR_NOTIFICATION: 'navigation_bar_notification',
  NAVIGATION_BAR_CART: 'navigation_bar_cart',
  NAVIGATION_BAR_RECIPE: 'navigation_bar_recipe',
  NAVIGATION_BAR_ORDERS: 'navigation_bar_orders',
  NAVIGATION_BAR_SHOPLIST: 'navigation_bar_shoplist',

  // Content selection events
  SELECT_BANNER: 'select_banner',
  SELECT_CATEGORY: 'select_category',
  SELECT_SUGGESTED_KEYWORD: 'select_suggested_keyword',
  SELECT_CONTENT: 'select_content',
  SELECT_ITEM: 'select_item',
  SELECT_PROMOTION: 'select_promotion',
  NAVIGATE_PROMO: 'navigate_promo',

  // Banner and promotional events
  CLICK_PROMO_DETAIL: 'click_promo_detail',
  CLICK_PROMO_OTHERS: 'click_promo_others',
  CLICK_PROMO_TAB: 'click_promo_tab',
  SCROLL_PROMO_LIST: 'scroll_promo_list',
  CLICK_EMPTY_PROMO_ACTION: 'click_empty_promo_action',
  CLICK_PROMO_SHARE: 'click_promo_share',
  CLICK_COPY_PROMO: 'click_copy_promo',

  CATEGORY: 'category',

  // Product-related events
  CLICK_PRODUCT: 'click_product',
  CLICK_PRODUCT_RELATED: 'click_product_related',
  CLICK_PRODUCT_CART: 'click_product_cart',
  CLICK_PRODUCT_OTHERS: 'click_product_others',
  CLICK_PRODUCT_TO_RECIPE: 'click_product_to_recipe',
  CLICK_ALL_PRODUCT_RELATED: 'click_all_product_related',
  GENERATE_LEAD: 'generate_lead',

  // Contact Sales events (for unavailable pricing)
  CONTACT_SALES_CTA_CLICK: 'contact_sales_cta_click',
  CONTACT_SALES_MODAL_VIEW: 'contact_sales_modal_view',
  CONTACT_SALES_MODAL_CONFIRM: 'contact_sales_modal_confirm',

  ADD_TO_CART: 'add_to_cart',
  PRE_ADD_TO_CART: 'pre_add_to_cart',
  SHOPPING_LIST_CART: 'shopping_list_cart',

  // Wishlist events
  ADD_TO_WISHLIST: 'add_to_wishlist',
  CLICK_REMOVE_WISHLIST: 'click_remove_wishlist',
  CLICK_PRODUCT_ADD_WISHLIST: 'click_product_add_wishlist',

  // Shopping list events
  ADD_TO_SHOPPING_LIST: 'add_to_shopping_list',
  CREATE_SHOPPING_LIST: 'create_shopping_list',
  DELETE_SHOPPING_LIST: 'delete_item_shopping_list',
  CLICK_SHOPPING_LIST_DETAIL: 'click_shopping_list_detail',
  CLICK_DELETE_ITEM_SHOPPING_LIST: 'delete_item_shopping_list',
  CLICK_EDIT_SHOPPING_LIST: 'click_edit_shopping_list',

  // Cart and checkout events
  VIEW_CART: 'view_cart',
  BEGIN_CHECKOUT: 'begin_checkout',
  REMOVE_FROM_CART: 'remove_from_cart',
  ADD_SHIPPING_INFO: 'add_shipping_info',
  ADD_PAYMENT_INFO: 'add_payment_info',
  PURCHASE: 'purchase',
  RETURN_TO_CART: 'return_to_cart',
  CLICK_CHECKOUT: 'click_checkout', // Keep for backward compatibility
  CLICK_CREATE_PO: 'click_create_po', // Keep for backward compatibility
  CLICK_NAVIGATE_CART: 'click_navigate_cart',
  CLICK_UPLOAD_PAYMENT_PROOF: 'click_upload_payment_proof',
  VIEW_PO_DETAIL_PAYMENT_PROOF_SECTION: 'view_po_detail_payment_proof_section',
  SUBMIT_PAYMENT_PROOF_SUCCESS: 'submit_payment_proof_success',
  VIEW_PAYMENT_INSTRUCTION: 'view_payment_instruction',
  CLICK_COPY_BANK_ACCOUNT: 'click_copy_bank_account',
  CLICK_COPY_AMOUNT: 'click_copy_amount',
  OCR_UPLOAD_STARTED: 'ocr_upload_started',
  OCR_UPLOAD_COMPLETED: 'ocr_upload_completed',
  VIEW_WAITING_PAYMENT_STICKY: 'view_waiting_payment_sticky',
  CLICK_WAITING_PAYMENT_STICKY: 'click_waiting_payment_sticky',
  CLICK_WAITING_PAYMENT_STICKY_LIST: 'click_waiting_payment_sticky_list',
  WFP_ROUTE_RESOLVED: 'wfp_route_resolved',
  PAYMENT_INSTRUCTION_SKIPPED: 'payment_instruction_skipped',
  VIEW_PO_DETAIL_WITH_VIEW_PARAM: 'view_po_detail_with_view_param',
  PAYMENT_INSTRUCTION_EXPIRED_VIEW: 'payment_instruction_expired_view',
  VOUCHER_RULE_ADD_PRODUCT: 'voucher_rule_add_product',
  VIEW_VOUCHER: 'view_voucher',
  CHOOSE_VOUCHER: 'choose_voucher',
  SEARCH_VOUCHER: 'search_voucher',
  SELECT_VOUCHER: 'select_voucher',
  CANCEL_VOUCHER: 'cancel_voucher',
  SUBMIT_VOUCHER: 'submit_voucher',

  // Upsell component events (Solusi Hemat! / Voucher Tersedia)
  VIEW_PROMO_UPSELL: 'view_promo_upsell',
  SELECT_PROMO_UPSELL: 'select_promo_upsell',
  VIEW_VOUCHER_UPSELL: 'view_voucher_upsell',
  SELECT_VOUCHER_UPSELL: 'select_voucher_upsell',

  // Frequently Bought Together (FBT) cross-sell events
  VIEW_ITEM_FBT: 'view_item_fbt',
  SELECT_ITEM_FBT: 'select_item_fbt',
  ADD_TO_CART_FBT: 'add_to_cart_fbt',

  // Recipe events
  SELECT_RECIPE: 'select_recipe',
  SEARCH_RECIPE: 'search_recipe',
  CLICK_RECIPE_SEARCH: 'click_recipe_search',
  CLICK_RECIPE_PRODUCT: 'click_recipe_product',
  CLICK_RECIPE_TUTORIAL: 'click_recipe_tutorial',
  CLICK_RECIPE_CART: 'click_recipe_cart',
  CLICK_RECIPE_OTHERS: 'click_recipe_others',
  ADD_TO_FAV_RECIPE: 'add_to_fav_recipe',

  // Search events
  DIAMOND_SEARCH: 'diamond_search',
  DIAMOND_VISIT: 'diamond_visit',
  DIAMOND_CHECKOUT: 'diamond_checkout',
  DIAMOND_PO_CREATED: 'diamond_po_created',
  DIAMOND_KEYWORD: 'diamond_keyword',

  // Time-based engagement events
  TIME_PRODUCT_DETAIL_PAGE: 'time_product_detail_page',
  TIME_PRODUCT_DETAIL_TO_CART: 'time_product_detail_to_cart',
  TIME_PROMO_DETAIL_PAGE: 'time_promo_detail_page',
  TIME_RECIPE_DETAIL_PAGE: 'time_recipe_detail_page',

  // Navigation events
  CLICK_BOTTOM_BAR_HOMEPAGE: 'click_bottom_bar_homepage',
  CLICK_BOTTOM_BAR_ORDER: 'click_bottom_bar_order',
  CLICK_BOTTOM_BAR_RECIPE: 'click_bottom_bar_recipe',
  CLICK_BOTTOM_BAR_SHOPLIST: 'click_bottom_bar_shoplist',
  CLICK_BOTTOM_BAR_ACCOUNT: 'click_bottom_bar_account',
} as const;

export const TRACKING_PAGES = {
  // Main pages
  BERANDA: 'Beranda',
  PRODUCT_LIST: 'Browse Product',
  PRODUCT_DETAIL: 'Detail Product',
  PRODUCT_RELATED: 'Produk Serupa',
  PRODUCT_HIGHLIGHT_MORE: 'Product Highlight',

  CART: 'Keranjang',
  CHECKOUT: 'Checkout',
  ORDER_DETAIL: 'Order Detail',
  MY_ORDER: 'My Order',

  PROMO_LIST: 'Promo',
  PROMO_DETAIL: 'Promo Detail',

  LOGIN: 'Login',
  REGISTER: 'Register',
  FORGOT_PASSWORD: 'Login',
  NOTIFICATION: 'Notification',
  PASSWORD_RECOVERY: 'Password Recovery',

  SHOPPING_LIST: 'Daftar Belanja',
  SHOPPING_LIST_DETAIL: 'Daftar Belanja Detail',
  RECIPE: 'Recipes',
  WISHLIST: 'Wishlist',
  ACCOUNT_DETAIL: 'Detail Akun',

  INVITATION: 'Invitation',

  // Product pages
  PRODUCT_SUGGESTIONS: 'Product Suggestions',

  // Recipe pages
  RECIPE_LIST: 'recipe_list',
  RECIPE_DETAIL: 'recipe_detail',
  RECIPE_FAVORITE: 'recipe_favorite',
  // Voucher pages
  VOUCHER: 'Voucher',
  VOUCHER_LIST: 'Voucher List',
  VOUCHER_DETAIL: 'Voucher Detail',
  // Authentication pages
  AKTIVASI: 'aktivasi',
  TOKEN_EXPIRED: 'token_expired',

  // Other pages
  SEARCH: 'search_product',
  CATEGORY: 'category',
  COMING_SOON: 'Coming Soon',
  NOT_FOUND: 'not_found',
} as const;

export type TrackingEventName =
  (typeof TRACKING_EVENTS)[keyof typeof TRACKING_EVENTS];

export type TrackingPageName =
  (typeof TRACKING_PAGES)[keyof typeof TRACKING_PAGES];
